import { store } from "../redux";
import { CLEAR_USER_SESSION, SET_USER_SESSION } from "../redux/actionTypes";
import cognitoUtils from "./cognito";

export function clearSession() {
    store.dispatch({
        type: CLEAR_USER_SESSION,
    });
}

export function initSession(session) {
    store.dispatch({ type: SET_USER_SESSION, session });
}

export const getUserSession = () => {
    const state = store.getState();
    return state.userSession;
};

export const getUserEmail = () => {
    const session = getUserSession();
    if (session.user === undefined) return null;
    let email = session.user.email;
    return email.toLowerCase();
};

export const getIdToken = () => {
    const session = getUserSession();
    if (session.credentials === undefined) return null;
    return session.credentials.idToken;
};

const decodeTokenPayload = (token) => {
    /**
     * Decode the payload part of the supplied JSON web token
     */
    let base64 = token.split(".")[1];
    return JSON.parse(window.atob(base64));
};

export const getTokenExpiry = (token) => {
    /**
     * Decodes and returns the expiry of the token as a Date object
     *
     * The expiry in our token is timestamp in seconds.
     */
    const decodedToken = decodeTokenPayload(token);
    // - 3500000 to debug
    return new Date(decodedToken.exp * 1000);
};

export const isTokenExpired = () => {
    /**
     * Returns true if the token has expired.
     *
     */
    const token = getIdToken();
    if (token === null) return true;
    let expiry = getTokenExpiry(token);
    return expiry <= new Date();
};

// Force Amplify to mint fresh tokens (using the refresh token it holds internally),
// store the resulting session and return it. Used by the Apollo TokenRefreshLink.
export const refreshAccessToken = () => {
    return cognitoUtils
        .fetchSession({ forceRefresh: true })
        .then((session) => {
            initSession(session);
            return session;
        })
        .catch((e) => {
            console.log("Failure refreshing session: " + JSON.stringify(e));
            throw new Error("Failure getting Cognito session");
        });
};

// Read the current (cached, auto-refreshed by Amplify) tokens and store the session.
export const updateAccessToken = () => {
    return cognitoUtils.fetchSession().then((session) => {
        store.dispatch({ type: SET_USER_SESSION, session });
        return session;
    });
};

export const isUserLoggedIn = () => {
    const session = getUserSession();
    let expired = isTokenExpired();
    return session.isLoggedIn && !expired;
};
